import React, { FunctionComponent, ReactElement } from "react"

interface IInformationLineProps {
  delay: number
  hideDelay?: number
  content: string | ReactElement
  loadingDots: boolean
  className?: string
}

const InformationLine: FunctionComponent<IInformationLineProps> = ({
  delay,
  hideDelay,
  content,
  loadingDots,
  className,
}) => {
  return (
    <div
      className="mt-2 flex opacity-0"
      style={{
        animation: `.1s linear ${delay}ms forwards reveal, ${
          hideDelay && `.1s linear ${hideDelay}ms forwards hide`
        }`,
      }}
    >
      <p className={`flex-1 typing items-center ${className ?? ""}`}>
        {content}
        {loadingDots && <span className="animate-pulse">...</span>}
      </p>
    </div>
  )
}

export default InformationLine
